import React, { FC } from "react";
import { Fab as MuiFab } from "@mui/material";

type Props = React.ComponentProps<typeof MuiFab>;

const Fab: FC<Props> = (props) => {
    return <MuiFab {...props}/>
}

export default Fab;